/**
 * GAUDIR — Navigation System  v4
 * File: assets/gaudir-nav.js
 *
 * Single responsibility:
 *   Offset the sticky nav to sit exactly below Broadcast's sticky header.
 *   Nothing else. No filtering, no state, no DOM manipulation.
 */
(function () {
  'use strict';
  var nav = document.getElementById('gn-nav');
  if (!nav) return;
  /* Broadcast theme header selectors — tries each in order */
  var HEADER_SELECTORS = [
    '.header-group',
    '[data-header-height]',
    '.site-header',
    '.header-wrapper',
    '#shopify-section-header',
    'header[role="banner"]',
    'header'
  ];
  function getHeader() {
    for (var i = 0; i < HEADER_SELECTORS.length; i++) {
      var el = document.querySelector(HEADER_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }
  function applyOffset() {
    var header = getHeader();
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    nav.style.top = h + 'px';
  }
  /* Initial call */
  applyOffset();
  /* React to window resize (orientation change, font scale, etc.) */
  window.addEventListener('resize', applyOffset, { passive: true });
  /* React to header height changes (e.g. sticky-shrink on scroll in Broadcast) */
  var header = getHeader();
  if (header && typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(applyOffset).observe(header);
  }
})();
